import React from 'react';
import './Templates.css';

export interface BeforeAfterTemplateData {
  beforeImage?: string;
  afterImage?: string;
  title?: string;
  description?: string;
  metrics?: {
    weightBefore?: number;
    weightAfter?: number;
    weightLoss?: number;
    measurements?: string;
  };
  logoUrl?: string;
}

interface BeforeAfterTemplateProps {
  data: BeforeAfterTemplateData;
  className?: string;
}

export const BeforeAfterTemplate: React.FC<BeforeAfterTemplateProps> = ({ data, className = '' }) => {
  const {
    beforeImage,
    afterImage,
    title = 'Transformação',
    description,
    metrics,
    logoUrl,
  } = data;

  const weightLoss = metrics?.weightLoss || 
    (metrics?.weightBefore && metrics?.weightAfter 
      ? metrics.weightBefore - metrics.weightAfter 
      : null);

  return (
    <div className={`before-after-template ${className}`} id="image-generator-template">
      <div className="template-container">
        {/* Header */}
        <div className="template-header">
          <h1 className="template-title">{title}</h1>
          {description && (
            <p className="template-description">{description}</p>
          )}
        </div>

        {/* Images Section */}
        <div className="before-after-images">
          <div className="before-after-item">
            <div className="image-label">ANTES</div>
            {beforeImage ? (
              <div className="image-container">
                <img src={beforeImage} alt="Antes" className="template-image" />
              </div>
            ) : (
              <div className="image-placeholder">
                <span>Imagem Antes</span>
              </div>
            )}
          </div>

          <div className="before-after-divider">
            <div className="divider-line"></div>
            <div className="divider-arrow">→</div>
            <div className="divider-line"></div>
          </div>

          <div className="before-after-item">
            <div className="image-label">DEPOIS</div>
            {afterImage ? (
              <div className="image-container">
                <img src={afterImage} alt="Depois" className="template-image" />
              </div>
            ) : (
              <div className="image-placeholder">
                <span>Imagem Depois</span>
              </div>
            )}
          </div>
        </div>

        {/* Metrics Section */}
        {metrics && (metrics.weightBefore || metrics.weightAfter || metrics.measurements) && (
          <div className="template-metrics">
            {metrics.weightBefore && metrics.weightAfter && (
              <div className="metric-item">
                <div className="metric-label">Peso</div>
                <div className="metric-value">
                  {metrics.weightBefore}kg → {metrics.weightAfter}kg
                  {weightLoss && weightLoss > 0 && (
                    <span className="metric-loss">-{weightLoss.toFixed(1)}kg</span>
                  )}
                </div>
              </div>
            )}
            {metrics.measurements && (
              <div className="metric-item">
                <div className="metric-label">Medidas</div>
                <div className="metric-value">{metrics.measurements}</div>
              </div>
            )}
          </div>
        )}

        {/* Watermark Logo */}
        {logoUrl && (
          <div className="template-watermark">
            <img src={logoUrl} alt="Logo" className="watermark-logo" />
          </div>
        )}
      </div>
    </div>
  );
};












